export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6639.88ef90e0.jpg";